export default __webpack_public_path__ + "static/media/warning.97f1b436.svg";